module.exports = {
    ADMIN_CONFIGURAR_USUARIOS: 'admin:configurar-usuarios',
    TIPO_DESCONTO_AMBOS: 'tipo-desconto:ambos',
    TIPO_DESCONTO_REAL: 'tipo-desconto:real',
    TIPO_DESCONTO_PORCENTO: 'tipo-desconto:porcento',
    MODO_DESCONTO_AMBOS: 'modo-desconto:ambos',
    MODO_DESCONTO_ITENS: 'modo-desconto:itens',
    MODO_DESCONTO_GERAL: 'modo-desconto:geral',
};